import { templatingRoutes, templatingNavigationItems } from "./router";
export class TemplatingModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[TemplatingModule] Registered");
        return {
            id: "templating",
            name: "Templating Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return templatingRoutes;
    }
    getNavigationItems() {
        return templatingNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[TemplatingModule] Unregistered");
        this.contracts = null;
    }
}
export default new TemplatingModule();
